/**
 * `@dxf-ai-editor/acadctb` — error factory shared across the parser
 * modules. Exposes a typed `ParseAcadctbError` with a `code` discriminator
 * so callers can branch on the failure category without parsing the
 * human-readable message.
 */

import type { ParseAcadctbError, ParseAcadctbErrorCode } from "./types";

export function makeError(
  code: ParseAcadctbErrorCode,
  message: string,
): ParseAcadctbError {
  const err = new Error(`acadctb: ${message}`) as ParseAcadctbError;
  err.code = code;
  return err;
}
